export class Profile{
    user_has_some_facturae_service: boolean
    constructor(){
        this.user_has_some_facturae_service = true //lo dejo en true para que asi no salga el boton de activar trial en facturae
    }
}